module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/desktop-app-5-00c3e4fa633e1b3509e74f786263678c.png";